// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-wrap[data-v-18d8a57d]{padding:17px 20px 22px 19px;border-radius:8px;background:#fff;margin-top:16px;height:324px}.card-empty[data-v-18d8a57d]{display:flex;justify-content:center;align-items:center;height:100%;color:#aaa;padding-top:20px}.card-empty[data-v-18d8a57d],.lookMore[data-v-18d8a57d]{font-weight:400;font-size:14px;text-align:center}.lookMore[data-v-18d8a57d]{margin-top:15px;cursor:pointer;color:#333}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
